import { useState } from 'react';
import { NavMarker } from 'react-rhumb';
import { Map as ImmutableMap } from 'immutable';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Subheader } from 'foundations-components/transitional/components/Header';
// @ts-expect-error Untyped module
import { RANGE_TYPES } from 'reporting-ui-components/components/shared/constants/DateRangeConstants';
// @ts-expect-error Untyped module
import getDefaultFrequency from 'reporting-ui-components/lib/getDefaultFrequency';
import { ContentObjectTypes, useContentObjectType } from 'content-management-data-lib';
import { DEFAULT_METRICS_TO_DISPLAY } from '../../constants/reporting';
import { useTrackPageView } from '../../hooks/useTrackPageView';
import { useAppSelector } from '../../reducers';
import { getHasLandingPagesWriteAccess, getHasSitePagesWriteAccess } from '../../selectors';
import MABEndTest from './MABEndTest';
import MABMetricCard from './MABMetricCard';
import MABNoData from './MABNoData';
import MABNotStarted from './MABNotStarted';
import MABViewsChart from './MABViewsChart';
import VariationsTableFilterBar from './VariationsTableFilterBar';
import MABVariantsTable from './MABVariantsTable';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PersonalizationHeader = ({
  mabExperiment,
  variationsList,
  canRenderMabEndTest
}) => {
  const {
    startedAt,
    metric
  } = mabExperiment;
  const startDate = I18n.moment(startedAt).format('LL');
  return /*#__PURE__*/_jsx(Subheader, {
    details: /*#__PURE__*/_jsxs("span", {
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "page-details-ui.testResults.personalization.subHeader",
        options: {
          startDate
        }
      }), canRenderMabEndTest && /*#__PURE__*/_jsxs(_Fragment, {
        children: [' |', ' ', /*#__PURE__*/_jsx(MABEndTest, {
          mabExperiment: mabExperiment,
          variationsList: variationsList
        })]
      })]
    }),
    headingLevel: "h4",
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: `page-details-ui.testResults.personalization.header.${metric}`
    }),
    marginBlockEnd: "0"
  });
};
const ReportingCharts = ({
  mabInfo,
  onMABReportMetricsChange,
  onNoData
}) => {
  const [metricsToDisplay, setMetricsToDisplay] = useState(DEFAULT_METRICS_TO_DISPLAY);
  const endDate = I18n.moment();
  const startDate = I18n.moment(mabInfo.mabExperiment.startedAt);
  const dateRange = {
    endDate: endDate.format('YYYY-MM-DD'),
    rangeType: RANGE_TYPES.CUSTOM,
    startDate: startDate.format('YYYY-MM-DD')
  };
  const frequency = getDefaultFrequency(ImmutableMap(dateRange));
  const mabIds = Object.keys(mabInfo.mabVariantsMap);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(MABMetricCard, {
      dateRange: dateRange,
      mabMetric: mabInfo.mabExperiment.metric,
      mabVariantsMap: mabInfo.mabVariantsMap,
      variantIds: mabIds,
      onMABReportMetricsChange: onMABReportMetricsChange,
      onNoData: onNoData
    }), /*#__PURE__*/_jsx(MABViewsChart, {
      dateRange: dateRange,
      frequency: frequency,
      variantIds: mabIds
    }), /*#__PURE__*/_jsx(VariationsTableFilterBar, {
      metricsToDisplay: metricsToDisplay,
      onColumnChange: updatedMetrics => {
        setMetricsToDisplay(updatedMetrics);
      }
    }), /*#__PURE__*/_jsx(MABVariantsTable, {
      dateRange: dateRange,
      metricsToDisplay: metricsToDisplay,
      mabVariantsMap: mabInfo.mabVariantsMap,
      variantIds: mabIds
    })]
  });
};
const Personalization = ({
  mabInfo
}) => {
  const {
    contentObjectType
  } = useContentObjectType();
  const userHasLandingPagesWriteAccess = useAppSelector(getHasLandingPagesWriteAccess);
  const userHasSitePagesWriteAccess = useAppSelector(getHasSitePagesWriteAccess);
  const canRenderMabEndTest = contentObjectType === ContentObjectTypes.LANDING_PAGE && userHasLandingPagesWriteAccess || contentObjectType === ContentObjectTypes.SITE_PAGE && userHasSitePagesWriteAccess;
  const {
    startedAt: mabStartedAt
  } = mabInfo.mabExperiment;
  const hasMabStarted = mabStartedAt > 0;
  const [variationsList, setVariationsList] = useState([]);
  const [hasNoData, setHasNoData] = useState(false);
  useTrackPageView('personalization');
  if (!hasMabStarted) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "PERSONALIZATION_NOT_STARTED_LOADED",
      children: /*#__PURE__*/_jsx(MABNotStarted, {})
    });
  } else if (hasNoData) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: "PERSONALIZATION_NO_DATA_LOADED",
      children: /*#__PURE__*/_jsx(MABNoData, {
        canRenderMabEndTest: canRenderMabEndTest,
        mabInfo: mabInfo
      })
    });
  }
  const handleMABReportMetricsChange = updatedVariantsList => {
    if (variationsList.length === 0) {
      setVariationsList(updatedVariantsList);
    }
  };
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs(NavMarker, {
      name: "PERSONALIZATION_LOADED",
      children: [/*#__PURE__*/_jsx(PersonalizationHeader, {
        mabExperiment: mabInfo.mabExperiment,
        variationsList: variationsList,
        canRenderMabEndTest: canRenderMabEndTest
      }), /*#__PURE__*/_jsx(ReportingCharts, {
        mabInfo: mabInfo,
        onMABReportMetricsChange: handleMABReportMetricsChange,
        onNoData: () => {
          setHasNoData(true);
        }
      })]
    })
  });
};
export default Personalization;